import React from "react";
import "./contact.css";
import Layout from "../../Components/Layout";

export default function Contact() {
  return (
    <Layout>
      <div className="contact-page">
        <div className="contact-info">

          <center>
            <h2>Contact Us </h2>
            <p>We'd love to hear from you!</p>
          </center>
          <a
            href="mailto:contact@bubble-computing.com"
            className="contact-item"
          >
            <span className="icon email-icon" aria-hidden="true"></span>
            <span>contact@bubble-computing.com</span>
          </a>
          
        </div>
      </div>
    </Layout>
  );
}
